//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { usePurchaseOptionsContext } from '@campaigns/components/shared/purchase-options/PurchaseOptionsContext';
import { PurchaseOptionsTableRowEditable } from '@campaigns/components/shared/purchase-options/purchase-options-table-row/PurchaseOptionsTableRowEditable';
import { PurchaseOptionsTableRowReadOnly } from '@campaigns/components/shared/purchase-options/purchase-options-table-row/PurchaseOptionsTableRowReadOnly';

interface PurchaseOptionsTableRowProps {
  purchaseOption: PurchaseOption;
}

export const PurchaseOptionsTableRow = ({
  purchaseOption,
}: PurchaseOptionsTableRowProps) => {
  const { readOnly } = usePurchaseOptionsContext();

  return readOnly ? (
    <PurchaseOptionsTableRowReadOnly purchaseOption={purchaseOption} />
  ) : (
    <PurchaseOptionsTableRowEditable purchaseOption={purchaseOption} />
  );
};
